import React, { memo } from 'react';
import CdnImage, { cdnImageTypes } from '@prisjakt/ui-cdn-image';
import { FontEmphasis } from '@prisjakt/ui/text/variants';

import * as S from './styles';

export const { VARIANTS } = S;

type Props = {
  className?: string;
  logoUrl?: string | null;
  name: string;
  storeId: number;
  featured?: boolean;
  hasImage: boolean;
  variant?: S.VARIANTS;
  width?: number;
  showHighResolutionLogo?: boolean; // Making image half the size
};

const StoreLogo = ({
  className,
  logoUrl,
  name,
  storeId,
  featured = false,
  hasImage,
  variant = S.VARIANTS.DEFAULT,
  width = 88,
  showHighResolutionLogo = false,
}: Props) => {
  const shouldRenderLogo =
    hasImage && (featured || variant === S.VARIANTS.CAMPAIGN);

  return (
    <S.StoreLogo
      showLogo={shouldRenderLogo}
      variant={variant}
      className={className}
      logoWidth={width}
      showHighResolutionLogo={showHighResolutionLogo}
    >
      {shouldRenderLogo ? (
        <CdnImage
          type={cdnImageTypes.store}
          name={storeId}
          width={width}
          alt={name}
          logoUrl={logoUrl}
        />
      ) : (
        <S.StoreLogoText emphasis={FontEmphasis.LOW}>{name}</S.StoreLogoText>
      )}
    </S.StoreLogo>
  );
};

export default memo(StoreLogo);
